import axios from "axios";
import CustomInterceptors from "@/api/auth/GAInterceptors";

const InstanceGA = axios.create({
    baseURL: process.env.VUE_APP_GLOBALAUTH_API
});

export default InstanceGA;